import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as SearchIcon } from "feather-icons/dist/icons/search.svg";
import { PrimaryButtonLink } from "./ui";

/** État vide (aucun résultat de recherche, catégorie sans article…). */

const Wrapper = tw.div`mt-12 py-16 px-8 rounded-lg bg-gray-100 text-center flex flex-col items-center`;
const IconCircle = styled.div`
  ${tw`w-16 h-16 rounded-full bg-primary-500 bg-opacity-10 text-primary-500 flex items-center justify-center`}
  svg {
    ${tw`w-8 h-8`}
  }
`;
const Title = tw.p`mt-6 text-xl font-bold text-gray-900`;
const Text = tw.p`mt-2 text-sm text-gray-600 font-medium max-w-md`;
const Action = tw(PrimaryButtonLink)`mt-8`;

export default function EmptyState({ title = "Aucun article ne correspond", text = "Essayez d'autres mots-clés ou parcourez toutes les catégories.", actionLabel = "Voir tous les articles", to = "/blog" }) {
  return (
    <Wrapper role="status">
      <IconCircle aria-hidden="true">
        <SearchIcon />
      </IconCircle>
      <Title>{title}</Title>
      {text && <Text>{text}</Text>}
      {actionLabel && <Action to={to}>{actionLabel}</Action>}
    </Wrapper>
  );
}
